import Horseshoe from '../../client/components/horseshoe';
import Board from '../../client/components/board/board';
import SearchResultBanners from '../../client/components/search-result-banners';

export default function init() {
    return {
        Horseshoe: Horseshoe,
        Board: Board,
        SearchResultBanners: SearchResultBanners,
    };
}
